import React, { useState, useEffect } from 'react';
import { formatTimestampToLocaleString } from '../utils/time';

const UTCTimer: React.FC = () => {
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex items-center space-x-2 text-xs">
      <svg className="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className="text-gray-300 font-mono text-xs">
        {formatTimestampToLocaleString(currentTime, 'en-US', {
          timeZone: 'Asia/Seoul',
          hour12: false,
        })} KST
      </span>
    </div>
  );
};

export default UTCTimer; 